import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, TextField, Typography } from '@mui/material';
import React, { useContext, useRef, useState } from 'react'
import { EliminarTipoServicio, GuardarNuevoTipoServicio } from '../../helpers/ServiciosHelper';
import { TiposServicioContext } from '../../pages/catalogos/ServiciosTipoPage';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
export const ModalEliminaTipoServicioComponent = () => {
    const {modalEliminaTipoServicio, setModalEliminaTipoServicio, obtenerTipos, tipoServicioSel} = useContext(TiposServicioContext);
    const [tipoServicio, setTipoServicio] = useState();
    const [errorGuardado, setErrorGuardado] = useState(false);
    const refForm = useRef();
    console.log('Valor de modal agrega', modalEliminaTipoServicio);

    const handleClose = () => {
        setModalEliminaTipoServicio(false);
    }

    const handleSubmit =  (event) => {
        event.preventDefault();
        //refForm.current.isValidate();
        EliminarTipoServicio(tipoServicioSel?.idTipoServicio).then(respuesta => {
            console.log('respuesta de guardado en modal', respuesta);
            if(respuesta!=1) {
                setErrorGuardado(true);
            } else{
                setErrorGuardado(false);
                obtenerTipos();
                handleClose();

            }
        })
    }

  return (
      <div
        style={{
            minWidth:600
        }}
    >
     <Dialog open={modalEliminaTipoServicio} onClose={handleClose}>
        <form onSubmit={handleSubmit} ref={refForm}>
        <DialogTitle>Tipo de Servicio</DialogTitle>
        <DialogContent
            style={{minWidth:600}}
        >
          ¿Eliminar el tipo de Servicio "{tipoServicioSel?.descripcion}"?
          {
            errorGuardado && (
              <Typography
                style={{
                    fontSize:12,
                    color:'red'
                }}
              >
                Error al guardar
            </Typography>
            )
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type='submit' >Eliminar</Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
